import React, { useContext, useEffect } from 'react'
import { func } from 'prop-types'

import { EngravingContext } from 'components/buy/Engraving/EngravingContext'
import Heading from 'components/buy/Engraving/Heading'
import EngravingOption from 'components/buy/Engraving/EngravingOption'
import List from 'components/buy/Engraving/List'
import MobileBack from 'components/buy/Engraving/MobileBack'

const InitialStep = ({ setStep }) => {
  const { engraving, setEngraving, currentView, setCurrentView } = useContext(EngravingContext)
  const { back } = engraving

  useEffect(() => {
    setCurrentView({ ...currentView, item: 'back', step: 'initialstep' })
  }, [])

  return (
    <>
      <Heading
        number="02"
        title="Now customize the Back"
        description="Add your name, initials, or a message to the back of your ePod"
        mobileBack={() => (
          <MobileBack
            onClick={() => {
              setEngraving({
                ...engraving,
                front: {
                  ...engraving.front,
                  proceeded: false
                }
              })
              setCurrentView({ item: 'front', step: 'initialstep' })
            }}
          />
        )}
      />
      <List row={3}>
        {Object.keys(back).map((key, idx) => {
          if (typeof back[key] !== 'boolean') {
            return (
              <EngravingOption
                key={idx}
                onClick={() => {
                  setStep(key)
                }}
                figure={back[key].slug}
                isLarge
                name={back[key].displayName}
              />
            )
          }

          return null
        })}
      </List>
    </>
  )
}

InitialStep.propTypes = {
  setStep: func.isRequired
}

export default InitialStep
